var map = {
	"./aeronautics.jpg": 4928,
	"./agriculture_fishing.jpg": 46310,
	"./arts_design.jpg": 94485,
	"./automotive.jpg": 51299,
	"./banking_insurance.jpg": 14809,
	"./banking_microfinance.jpg": 91035,
	"./beauty_cosmetics.jpg": 2377,
	"./communications_media.jpg": 58166,
	"./computers_software.jpg": 69894,
	"./construction_renovation.jpg": 76479,
	"./consulting_business.jpg": 27987,
	"./education_academic.jpg": 45260,
	"./electronics.jpg": 62343,
	"./energy_utilities.jpg": 3109,
	"./engineering_architecture.jpg": 77253,
	"./entertainment_events.jpg": 22714,
	"./financial_services.jpg": 88695,
	"./fitness.jpg": 90626,
	"./governmental.jpg": 9926,
	"./handicraft.jpg": 77362,
	"./health_care.jpg": 63364,
	"./housekeeping_maintenance.jpg": 33829,
	"./human_resources.jpg": 72539,
	"./import_export.jpg": 85658,
	"./legal_accounting.jpg": 48193,
	"./manufacturing.jpg": 19272,
	"./marketing_advertising.jpg": 24877,
	"./non_profit_social.jpg": 25842,
	"./outsourcing_leasing.jpg": 75314,
	"./raw_materials.jpg": 97151,
	"./real_estate.jpg": 88181,
	"./restaurant_hospitality.jpg": 74762,
	"./retail_wholesale.jpg": 67487,
	"./security.jpg": 3966,
	"./telecommunications.jpg": 95443,
	"./textile_fashion.jpg": 912,
	"./transportation_logistics.jpg": 89466,
	"images/industries/aeronautics.jpg": 4928,
	"images/industries/agriculture_fishing.jpg": 46310,
	"images/industries/arts_design.jpg": 94485,
	"images/industries/automotive.jpg": 51299,
	"images/industries/banking_insurance.jpg": 14809,
	"images/industries/banking_microfinance.jpg": 91035,
	"images/industries/beauty_cosmetics.jpg": 2377,
	"images/industries/communications_media.jpg": 58166,
	"images/industries/computers_software.jpg": 69894,
	"images/industries/construction_renovation.jpg": 76479,
	"images/industries/consulting_business.jpg": 27987,
	"images/industries/education_academic.jpg": 45260,
	"images/industries/electronics.jpg": 62343,
	"images/industries/energy_utilities.jpg": 3109,
	"images/industries/engineering_architecture.jpg": 77253,
	"images/industries/entertainment_events.jpg": 22714,
	"images/industries/financial_services.jpg": 88695,
	"images/industries/fitness.jpg": 90626,
	"images/industries/governmental.jpg": 9926,
	"images/industries/handicraft.jpg": 77362,
	"images/industries/health_care.jpg": 63364,
	"images/industries/housekeeping_maintenance.jpg": 33829,
	"images/industries/human_resources.jpg": 72539,
	"images/industries/import_export.jpg": 85658,
	"images/industries/legal_accounting.jpg": 48193,
	"images/industries/manufacturing.jpg": 19272,
	"images/industries/marketing_advertising.jpg": 24877,
	"images/industries/non_profit_social.jpg": 25842,
	"images/industries/outsourcing_leasing.jpg": 75314,
	"images/industries/raw_materials.jpg": 97151,
	"images/industries/real_estate.jpg": 88181,
	"images/industries/restaurant_hospitality.jpg": 74762,
	"images/industries/retail_wholesale.jpg": 67487,
	"images/industries/security.jpg": 3966,
	"images/industries/telecommunications.jpg": 95443,
	"images/industries/textile_fashion.jpg": 912,
	"images/industries/transportation_logistics.jpg": 89466
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24978;